<div
  class="interface-control__time-input__container"
  [ngClass]="{
    'interface-control__time-input__container--valid': state === 0 && !data.locked,
    'interface-control__time-input__container--invalid': state === 1 && !data.locked,
    'interface-control__time-input__container--active': state === 2 && !data.locked,
    'interface-control__time-input__container--inactive': state === 3 && !data.locked,
    'interface-control__time-input__container--locked': data.locked
  }"
>
  <number-spinner
    *ngIf="enableInputTimezone"
    [fieldContainer]="inputMaskText"
    [size]="'sm'"
    [disabled]="disabled || data.locked"
    [externalState]="state"
    (spinChange)="handleSpin($event)"
    [min]="null"
    [max]="null"
  ></number-spinner>
  <ng-template #inputMaskText>
    <bfx-time-edit
      *ngIf="enableInputTimezone"
      #inputTime
      [(ngModel)]="data.timeValue"
      (ngModelChange)="onValuesChange()"
      (onBlur)="onBlur($event)"
      (onFocus)="onFocus($event)"
      [mask]="data.mask"
      [disabled]="disabled || data.locked"
      autoFocus="true"
      [styleClass]="{
      'bfx-field-text': true,
      'bfx-field-inputted-sm-subtle': true,
      'bfx-field-invalid-subtle': state === 1 && !data.locked
    }"
      [ngClass]="{
      'interface-control__time-input__input': true,
      'interface-control__time-input__input--valid': state === 0 && !data.locked,
      'interface-control__time-input__input--invalid': state === 1 && !data.locked,
      'interface-control__time-input__input--active': state === 2 && !data.locked,
      'interface-control__time-input__input--inactive': state === 3 && !data.locked,
      'interface-control__time-input__input--locked': data.locked
    }"
    ></bfx-time-edit>
  </ng-template>
  <bfx-autoComplete
    #inputTimezone
    [(ngModel)]="data.timezoneValue"
    (ngModelChange)="onBlur($event)"
    [suggestions]="data.timezoneDatasetFiltered"
    (completeMethod)="filterTimezones($event)"
    [disabled]="disabled || data.locked"
    (onFocus)="onFocus($event)"
    (onBlur)="onBlur($event)"
    dataKey="dataItem"
    field="label"
    [autoHighlight]="true"
    [skipSorting]="true"
    delay="4"
    [maxlength]="4"
    [nativeDesktopDropdown]="timeInputName"
    [nativeDesktopActiveWindow]="timeInputName"
    [target]="timeInputName"
    [state]="state"
    [dropdown]="true"
    [minLength]="0"
    [size]="'sm'"
    [appendTo]="'body'"
    class="interface-control__time-input__dropdown"
    dropdownMenuClass="interface-control__time-input__dropdown"
    [ngClass]="{
      'interface-control__time-input__dropdown--valid': state === 0 && !data.locked,
      'interface-control__time-input__dropdown--invalid': state === 1 && !data.locked,
      'interface-control__time-input__dropdown--active': state === 2 && !data.locked,
      'interface-control__time-input__dropdown--inactive': state === 3 && !data.locked,
      'interface-control__time-input__dropdown--locked': data.locked
    }"
    [fieldStartContainer]="inputMaskAutocomplete"
  >
    <ng-template let-dataItem pTemplate="item">
      <div class="ui-helper-clearfix">
        <div>{{dataItem.label}}</div>
      </div>
    </ng-template>
    <ng-template #inputMaskAutocomplete let-numberSpinnerInput="numberSpinnerInput">
      <bfx-time-edit
        *ngIf="enableInputTimezone == false"
        #inputTime
        [(ngModel)]="data.timeValue"
        (onBlur)="onBlur($event)"
        (onFocus)="onFocus($event)"
        [mask]="data.mask"
        [disabled]="disabled || data.locked"
        autoFocus="true"
        [spinner]="numberSpinnerInput"
        [styleClass]="{
          'bfx-field-text': true,
          'bfx-field-inputted-sm-subtle': state !== 2 || data.locked,
          'bfx-field-invalid-subtle': state === 1 && !data.locked,
          'bfx-field-inputted-active-sm-subtle': state === 2 && !data.locked
        }"
        [ngClass]="{
          'interface-control__time-input__input': true,
          'interface-control__time-input__input--valid': state === 0 && !data.locked,
          'interface-control__time-input__input--invalid': state === 1 && !data.locked,
          'interface-control__time-input__input--active': state === 2 && !data.locked,
          'interface-control__time-input__input--inactive': state === 3 && !data.locked,
          'interface-control__time-input__input--locked': data.locked
        }"
      >
      </bfx-time-edit>
    </ng-template>
  </bfx-autoComplete>
</div>
